<template>
    <div>
     
        <main class="d-flex justify-content-center inicio-home">
            
            <div class="container p-5">
                <div class="row d-flex justify-content-center">
                   
                    <div class="col-md-8  bg-body rounded shadow-sm p-5">
                    <h3 class="d-flex justify-content-start">Status operaciones</h3>
                    <br>
                    <ul class="nav nav-tabs nav-fill" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link active" id="verificando-tab" data-bs-toggle="tab" data-bs-target="#verificando" type="button" role="tab" aria-controls="verificando" aria-selected="true">En proceso</button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="finalizada-tab" data-bs-toggle="tab" data-bs-target="#finalizada" type="button" role="tab" aria-controls="finalizada" aria-selected="false">Finalizada</button>
                        </li>
                    </ul>


                      <div class="tab-content">
                        <div class="tab-pane active" id="verificando" role="tabpanel" aria-labelledby="verificando-tab"> <br>
                          <div v-if="isLoad">
                          <div v-for="(linea,index) in listOperationProceso" :key="index"> 
                            <div v-if="linea.IdTipoCompraVenta==1" class="d-flex justify-content-between">
                              <div class="col-md-6 d-flex justify-content-start">
                                  <ul class="list-ope">
                                      <li class="item-op-1">Enviaste</li>
                                      <li class="moneda">S/ {{linea.MontoSoles|numeral('0,0.00')}}</li>
                                      <li class=""> <span> Compraste a:</span> {{linea.TipoCambioActual}}</li>
                                      <li class="">{{linea.FechaRegistro}}</li>
                                  </ul>
                              </div>
                              <div class="col-md-6 d-flex justify-content-end">
                                  <ul class="list-ope">
                                      <li class="item-op-1">Recibirás</li>
                                      <li class="moneda">$ {{linea.MontoDolares|numeral('0,0.00')}}</li>
                                      <li class=""><a href="" data-bs-toggle="modal" data-bs-target="#detalle" @click="verDetalle(linea.Url_DetalleOperacion)">Detalle <i class="fas fa-arrow-right"></i></a></li>
                                 </ul>
                              </div>
                            </div>
                            <div v-else class="d-flex justify-content-between">
                                <div class="col-md-6 d-flex justify-content-start">
                                    <ul class="list-ope">
                                        <li class="item-op-1">Enviaste</li>
                                        <li class="moneda">$ {{linea.MontoDolares|numeral('0,0.00')}}</li>
                                        <li class=""> <span> Vendiste a:</span> {{linea.TipoCambioActual}}</li>
                                        <li class="">{{linea.FechaRegistro}}</li>
                                    </ul>
                                </div>
                                <div class="col-md-6 d-flex justify-content-end">
                                    <ul class="list-ope">
                                        <li class="item-op-1">Recibiste</li>
                                        <li class="moneda">S/ {{linea.MontoSoles|numeral('0,0.00')}}</li>
                                       <li class=""><a href="" data-bs-toggle="modal" data-bs-target="#detalle" @click="verDetalle(linea.Url_DetalleOperacion)">Detalle <i class="fas fa-arrow-right"></i></a></li>
                                   </ul>
                                </div>
                            </div>
                            <hr>
                          </div>
                          <div v-if="listOperationProceso==''">
                              <div class="text-center"><img src="@/assets/img/billetera.png" alt=""></div> 
                              <br>
                              <h4 class="titulo-registro text-center">No tienes operaciones en proceso </h4> <br>
                          </div>
                         </div> 
                         <div v-if="!isLoad" class="cargando"></div>
                        </div>
                        <div class="tab-pane" id="finalizada" role="tabpanel" aria-labelledby="finalizada-tab"> <br>
                          <div v-if="isLoad">
                          <div v-for="(linea,index) in listOperationFin" :key="index" > 
                            <div v-if="linea.IdTipoCompraVenta==1" class="d-flex justify-content-between">
                              <div class="col-md-6 d-flex justify-content-start">
                                  <ul class="list-ope">
                                      <li class="item-op-1">Enviaste</li>
                                      <li class="moneda">S/ {{linea.MontoSoles|numeral('0,0.00')}}</li>
                                      <li class=""> <span> Compraste a:</span> {{linea.TipoCambioActual}}</li>
                                      <li class="">{{linea.FechaRegistro}}</li>
                                  </ul>
                              </div>
                              <div class="col-md-6 d-flex justify-content-end">
                                  <ul class="list-ope">
                                      <li class="item-op-1">Recibiste</li>
                                      <li class="moneda">$ {{linea.MontoDolares|numeral('0,0.00')}}</li>
                                      <li class=""><a href="" data-bs-toggle="modal" data-bs-target="#detalle" @click="verDetalle(linea.Url_DetalleOperacion)">Detalle <i class="fas fa-arrow-right"></i></a></li>
                                 </ul>
                              </div>
                            </div>
                            <div v-else class="d-flex justify-content-between">
                                <div class="col-md-6 d-flex justify-content-start">
                                    <ul class="list-ope">
                                        <li class="item-op-1">Enviaste</li>
                                        <li class="moneda">$ {{linea.MontoDolares|numeral('0,0.00')}}</li>
                                        <li class=""> <span> Vendiste a:</span> {{linea.TipoCambioActual}}</li>
                                        <li class="">{{linea.FechaRegistro}}</li>
                                    </ul>
                                </div>
                                <div class="col-md-6 d-flex justify-content-end">
                                    <ul class="list-ope">
                                        <li class="item-op-1">Recibiste</li>
                                        <li class="moneda">S/ {{linea.MontoSoles|numeral('0,0.00')}}</li>
                                        <li class=""><a href="" data-bs-toggle="modal" data-bs-target="#detalle" @click="verDetalle(linea.Url_DetalleOperacion)">Detalle <i class="fas fa-arrow-right"></i></a></li>
                                   </ul>
                                </div>
                              </div>
                              <hr>
                            </div>
                            <div v-if="listOperationFin==''">
                              <div class="text-center"><img src="@/assets/img/billetera.png" alt=""></div> 
                              <br>
                              <h3 class="titulo-registro text-center">No tienes operaciones finalizadas</h3> <br>
                            </div>
                          </div> 
                          <div v-if="!isLoad" class="cargando"></div>
                        </div>

                      </div>

                    </div>
                </div>
            </div>
        </main>
   
<!-- Modal -->
<div class="modal fade" id="detalle" tabindex="-1" aria-labelledby="detalleLabel" aria-hidden="true">
  <div class="modal-dialog">
  <div class="modal-content">
      <div class="m"><button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button></div>
     
                <iframe :src="modal.url" allowtransparency="100%" frameborder="1" width="100%" height="780px" scrolling="no"></iframe>
     
  </div>
  </div>
</div><!-- Modal -->

</div>
</template>

<script>
import moment from 'moment'
import auth from '@/services/auth'

  export default {
    name: "OperacionesVerificando",

    data() {
    return {
      modal:{
        url:"",
      },
      isLoad:false,
      listOperationProceso:[],
      listOperationFin:[],
    };
  },

  mounted(){
    window.scrollTo(0, 0);
    this.esperarTiempo();
    auth.listOperation(this).then(response => {
      this.listOperationProceso=response.filter(e=>e.IdEstadoProceso=="ESOP0001");
      this.listOperationFin=response.filter(e=>e.IdEstadoProceso=="ESOP0002");
      this.isLoad = true
    });
  },
  methods:{
    verDetalle(url){
        this.modal.url=url;
    },
    esperarTiempo() {
       setTimeout(function() {
           //this.isLoad = true
       }.bind(this), 1000);
    }
  },
  };
  </script>


// WEBPACK FOOTER //
// src/components/user/OperacionesVerificando.vue